// i18n
import translate from 'locales/i18n';
//Store
import AccountStore from 'stores/AccountStore';

export const displayPrice = (price) => translate.i18n(price.element) + ' ' + (parseInt(price.value) < 0 ? ' - ' + Math.abs(price.value) : ' + ' + price.value) + ' ' + (price.mode === 'PERCENTAGE' ? '%' : AccountStore.getCurrentAccount().getCurrency());

export const displayDate = (date) => date.split('-')[2]+'/'+date.split('-')[1]+'/'+date.split('-')[0];
